import imageCompression from "browser-image-compression";

const compressImage = async (file) => {
  const options = {
    maxSizeMB: 1, // Target size in MB
    maxWidthOrHeight: 1080, // Resize the larger dimension
    useWebWorker: true, // Use Web Workers for faster compression
    fileType: "image/jpeg", // Convert to JPEG format
  };

  // console.log("Original File:", file);

  try {
    const compressedFile = await imageCompression(file, options);
    // console.log("Compressed File:", compressedFile);

    // Optionally: Convert to base64 or upload
    const base64Data = await imageCompression.getDataUrlFromFile(compressedFile);
    // console.log("Base64 Data:", base64Data);
    return base64Data;
  } catch (error) {
    console.error("Error compressing the image:", error);
    return null;
  }
};

export default compressImage;
